import type { $Fetch } from 'ofetch';
import type { LgpdGateway } from '@/application/port/out/LgpdGateway';
import type { LgpdConsentimento, LgpdSolicitacao, RegistrarConsentimentoCommand } from '@/domain/model/Lgpd';
import type { ApiResponse } from '@/infrastructure/http/types';
import { assertApiSuccess } from '@/infrastructure/http/assertApiSuccess';

const ROOT = '/api/v1/lgpd/me';

/** HTTP gateway dos direitos do titular LGPD. Authority BE: `lgpd:titular:exercer`. */
export class HttpLgpdGateway implements LgpdGateway {
  constructor(private readonly client: $Fetch) {}

  async exportarDados(): Promise<unknown> {
    const res = await this.client<ApiResponse<unknown>>(`${ROOT}/dados`, { method: 'GET' });
    assertApiSuccess(res);
    return res.data;
  }

  async solicitarExclusao(motivo: string | null): Promise<LgpdSolicitacao> {
    const res = await this.client<ApiResponse<LgpdSolicitacao>>(
      `${ROOT}/solicitar-exclusao`, { method: 'POST', body: motivo ? { motivo } : {} });
    assertApiSuccess(res);
    return res.data;
  }

  async listConsentimentos(): Promise<LgpdConsentimento[]> {
    const res = await this.client<ApiResponse<LgpdConsentimento[]>>(`${ROOT}/consentimento`, { method: 'GET' });
    assertApiSuccess(res);
    return res.data;
  }

  async registrarConsentimento(cmd: RegistrarConsentimentoCommand): Promise<LgpdConsentimento> {
    const res = await this.client<ApiResponse<LgpdConsentimento>>(
      `${ROOT}/consentimento`, { method: 'POST', body: cmd });
    assertApiSuccess(res);
    return res.data;
  }
}
